import React from 'react';
import { CheckCircle2 } from 'lucide-react';
export function About() {
  return <section id="about" className="py-24 bg-white overflow-hidden" data-id="element-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-9">
        <div className="flex flex-col lg:flex-row items-center gap-16" data-id="element-10">
          {/* Image Side */}
          <div className="w-full lg:w-1/2 relative" data-id="element-11">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl aspect-[4/3]" data-id="element-12">
              <img src="https://cdn.magicpatterns.com/uploads/w2urgKRPyZ1cYFaQJgmNbh/20240508_164307.jpg" alt="Professional lawn mower on a beautifully manicured lawn" className="w-full h-full object-cover" data-id="element-13" />
              <div className="absolute inset-0 bg-emerald-900/10 mix-blend-multiply" data-id="element-14"></div>
            </div>

            {/* Floating Badge */}
            <div className="absolute -bottom-6 -right-6 bg-white p-6 rounded-2xl shadow-xl border border-gray-100 hidden md:block" data-id="element-15">
              <div className="flex items-center gap-4" data-id="element-16">
                <div className="bg-emerald-100 text-emerald-600 font-bold text-3xl p-4 rounded-xl" data-id="element-17">
                  2
                </div>
                <div data-id="element-18">
                  <p className="text-gray-900 font-bold text-lg" data-id="element-19">Years of</p>
                  <p className="text-gray-500 font-medium" data-id="element-20">Experience</p>
                </div>
              </div>
            </div>
          </div>

          {/* Content Side */}
          <div className="w-full lg:w-1/2" data-id="element-21">
            <h2 className="text-emerald-600 font-semibold tracking-wide uppercase text-sm mb-3" data-id="element-22">
              About Us
            </h2>
            <h3 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-23">
              Family-Owned Since 2024
            </h3>

            <div className="space-y-6 text-lg text-gray-600 mb-8" data-id="element-24">
              <p data-id="element-25">
                Green Valley Lawncare started in 2024 with a simple mission: to
                provide our community with reliable, high-quality lawn care
                services that homeowners can trust. We focus on what we do
                best—keeping your lawn healthy and beautiful through expert
                mowing, aeration, and fertilization.
              </p>
              <p data-id="element-26">
                We treat every lawn as if it were our own. Our team uses
                top-of-the-line equipment and eco-friendly practices to ensure
                your property looks its absolute best, week after week, season
                after season.
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-10" data-id="element-27">
              <div className="flex items-start gap-3" data-id="element-28">
                <CheckCircle2 className="h-6 w-6 text-emerald-500 flex-shrink-0 mt-0.5" data-id="element-29" />
                <div data-id="element-30">
                  <h4 className="font-bold text-gray-900" data-id="element-31">Reliable Service</h4>
                  <p className="text-sm text-gray-600" data-id="element-32">
                    We show up when we say we will.
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-3" data-id="element-33">
                <CheckCircle2 className="h-6 w-6 text-emerald-500 flex-shrink-0 mt-0.5" data-id="element-34" />
                <div data-id="element-35">
                  <h4 className="font-bold text-gray-900" data-id="element-36">Expert Team</h4>
                  <p className="text-sm text-gray-600" data-id="element-37">
                    Trained, uniformed professionals.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-3" data-id="element-38">
                <CheckCircle2 className="h-6 w-6 text-emerald-500 flex-shrink-0 mt-0.5" data-id="element-39" />
                <div data-id="element-40">
                  <h4 className="font-bold text-gray-900" data-id="element-41">
                    Satisfaction Guarantee
                  </h4>
                  <p className="text-sm text-gray-600" data-id="element-42">
                    We aren't happy until you are.
                  </p>
                </div>
              </div>
            </div>

            <a href="#contact" className="inline-flex items-center justify-center px-6 py-3 text-base font-medium text-white bg-gray-900 rounded-lg hover:bg-gray-800 transition-colors shadow-sm" data-id="element-43">
              Contact Our Team
            </a>
          </div>
        </div>
      </div>
    </section>;
}